import { getRule } from './rule'
import axios from 'axios'
// import Config from '@/hostConfig'
const Config = process.env
export { coverConfig } from './coverConfig'

const maskMap = {}

function isArrayFn(o) {
  return Object.prototype.toString.call(o) === '[object Array]'
}
async function getSourceData(str, key) {
  if (maskMap[str]) {
    return maskMap[str]
  }
  const rule = getRule(str, key)
  if (rule.type === 'default') {
    maskMap[str] = str
    return str
  } else {
    const res = await axios({
      method: 'POST',
      // url: Config.VUE_APP_API + '/call-center/callCenter/convertOriginalTextBatch',
      url: Config.VUE_APP_HOST_THAAD + '/thaad/getOriginalTextBatch',
      headers: {
        'from-app': 'customer-service-workbench', // 来源标识，package.json中的serverName
        'thaad-access-key': 'internal_rest'
      },
      data: {
        value: { [rule.type]: [str] }
      },
      withCredentials: true
    })
    const data = res.data?.data?.[rule.type] ? res.data?.data?.[rule.type]?.[0] : str
    maskMap[str] = data
    return data
  }
}

export function localCover(data, keys, onlyMask = []) {
  // 单个字段翻译处理
  if (!data) return data
  if (isArrayFn(data)) {
    if (!data.length) return data
    data.forEach(node => {
      keys.forEach(key => {
        node['_' + key] = getSourceData.bind(null, node[key], key)
      })
    })
  } else {
    keys.forEach(key => {
      data['_' + key] = getSourceData.bind(null, data[key], key)
    })
  }
  // 接口返回的是掩码数据
  return data
}
